<template>
  <div class="choose-box-pay">
    <div v-for="(item, index) in options" :key="index" class="choose-item"
      :class="item.payCode === 'wechat' ? 'wechat' : 'alipay'" @click=" localValue = item.payCode">
      <i
        :class="item.payCode === localValue ? 'uc-font uc-checkbox-circle-on uc-blue' : 'uc-font uc-checkbox-circle'"></i>
      <img :src="item.img" class="uc-img" alt="">
      <div class="c" :class="item.payCode === 'wechat' ? 'w' : ''">{{ item.payName }}</div>

    </div>
  </div>
</template>

<script>
import sgOptionsMixin from '@/mixins/sg-options.mixin';
import { payList } from "@/api/annual-report"
export default {
  name: 'choosePay',
  mixins: [sgOptionsMixin],
  props: {
    options: {
      type: Array,
      default: () => [
        {
          payName: '微信支付',
          payCode: 'wechat',
          img: require("../assets/pay/wx2.png")
        },
        {
          payName: '支付宝',
          payCode: 'alipay',
          img: require("../assets/images/pay-2.png")
        },
        // {
        //   payName: '银行卡',
        //   payCode: 'yhk',
        //   img: require("../assets/zx/yhk.png")
        // },
      ],
    },
  },
  created() {
    //this.getPayList()
  },
  methods: {
    getPayList() {
      payList({
        pageNo: 1,
        pageSize: 10
      }).then(res => {
        if (res.success) {
          this.options = res.data
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.choose-box-pay {
  display: flex;
  //flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  .choose-item {
    flex: 1;
    min-width: 0px;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-basis: 160px;
    flex-grow: 0;

    &:nth-child(2n) {
      margin-left: 15px;
    }

    .uc-img {
      width: 40px;
      height: 40px;
    }

    .uc-blue {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #659FFF;
    }
  }

  .alipay {
    width: 160px;
    height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(136,155,193,0.302);
    border-radius: 2px 2px 2px 2px;
  }

  .wechat {
    width: 160px;
    height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(136,155,193,0.302);
    border-radius: 2px 2px 2px 2px;
  }

  .c {
    min-width: 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    margin-left: 4px;
    margin-right: 6px;
  }

  .w {
    margin-left: 5px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
  }

  img {
    display: block;
  }

  .uc-font {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #659FFF;
    margin-right: 8px;
  }
}
</style>